/* eslint-disable no-extra-boolean-cast */
import {
  WAIT_UPDATE,
  FOREIGN_COUNTRY,
  MALE,
  FEMALE,
  VIET_NAM,
  NOT_EXIST,
  NOT_UPDATE
} from "~/utils/constants";
import moment from "moment";
import { getFormatMoney } from "~/utils/getFormatMoney";
import { get } from "lodash";

// LOGO
// import logoUMC from "~/assets/img/common/logo/logo_y_duoc.png";
// import logoDaLieu from "~/assets/img/common/logo/logo_dalieu.png";
// import logoNhiDong1 from "~/assets/img/common/logo/logo_nhidong.png";
// import logoCTCH from "~/assets/img/common/logo/logo_ctch.png";
// import logoMinhAnh from "~/assets/img/common/logo/logo_minhanh.png";
// import logoThuDuc from "~/assets/img/common/logo/logo_thuduc.png";

// COLOR
// const COLOR_DALIEU = "#028c44";
// const COLOR_UMC = "#0a519f";
// const COLOR_NHI_DONG_1 = "#0070b6";
// const COLOR_MINH_ANH = "#db2032";

// Hospital ID
const UMC_HOSPITAL = 2; // BỆnh viện đại học y dược
const SKIN_HOSPITAL = 3; // BỆnh viện da liễu
const KID1_HOSPITAL = 4; // BỆnh viện nhi đồng 1
const MINHANH_HOSPITAL = 5; // BỆnh viện minh anh
const CTCH_HOSPITAL = 6; // Bệnh viện CTCH
const THUDUC_HOSPITAL = 7; // BỆnh viện thủ đức

// Route afet choose hospital
const HOME_URL = "/";

const DAT_KHAM = 7;
const DAT_KHAM_URL = "/chon-hinh-thuc-dat-kham";
const DAT_KHAM_ONE_FEATURE_URL = "/chon-ho-so";

const DAT_KHAM_THEO_NGAY = 1;

const DAT_KHAM_THEO_BS = 2;

const TAI_KHAM = 3;
const TAI_KHAM_URL = "/lich-tai-kham";

const THANH_TOAN_VIEN_PHI = 4;
const THANH_TOAN_VIEN_PHI_URL = "/thanh-toan-vien-phi-noi-tru";

const XEM_KET_QUA_CAN_LAM_SANG = 5;
const XEM_KET_QUA_CAN_LAM_SANG_URL = "/can-lam-sang";

const CHATBOX = 6;
const CHATBOX_URL = "/tu-van-kham-benh-truc-tuyen";

// Route after choose/insert/search patient
const CHON_LICH_KHAM = "/chon-lich-kham";
const CHON_CHUYEN_KHOA = "/chon-chuyen-khoa";
const CHON_BAC_SI = "/chon-bac-si";
const DANH_SACH_LICH_TAI_KHAM = "/danh-sach-lich-tai-kham";
const KET_QUA_CAN_LAM_SANG = "/ket-qua-can-lam-sang";

export const processFlowRouting = (selectedFeature, selectedHospital) => {
  const selectedFeatureID = Number(selectedFeature);
  const selectedHospitalId = Number(selectedHospital.id);

  const { router } = getInfoFollowHospital(selectedHospitalId);

  let routingAfterChooseHospital = HOME_URL;
  let routingAfterChoosePatient = HOME_URL;

  switch (selectedFeatureID) {
    case DAT_KHAM: {
      switch (selectedHospitalId) {
        case 2: {
          routingAfterChooseHospital = router + DAT_KHAM_URL;
          break;
        }
        default: {
          routingAfterChooseHospital = router + DAT_KHAM_ONE_FEATURE_URL;
          break;
        }
      }
      break;
    }

    case DAT_KHAM_THEO_NGAY: {
      /*
        Luồng đặt khám theo ngày: step sau khi chọn BV:
              - Chọn lịch khám: umc (2), thuduc (7)
              - Chọn chuyên khoa: dalieu (3), nhidong1 (4), ctch (6)
      */
      switch (selectedHospitalId) {
        case 2:
        case 7: {
          routingAfterChoosePatient = router + CHON_LICH_KHAM;
          break;
        }
        case 3:
        case 4:
        case 6: {
          routingAfterChoosePatient = router + CHON_CHUYEN_KHOA;
          break;
        }
        default: {
          break;
        }
      }
      break;
    }

    case DAT_KHAM_THEO_BS: {
      routingAfterChoosePatient = router + CHON_BAC_SI;
      break;
    }

    case TAI_KHAM: {
      routingAfterChooseHospital = router + TAI_KHAM_URL;
      routingAfterChoosePatient = router + DANH_SACH_LICH_TAI_KHAM;
      break;
    }

    case THANH_TOAN_VIEN_PHI: {
      routingAfterChooseHospital = router + THANH_TOAN_VIEN_PHI_URL;
      break;
    }

    case XEM_KET_QUA_CAN_LAM_SANG: {
      routingAfterChooseHospital = router + XEM_KET_QUA_CAN_LAM_SANG_URL;
      routingAfterChoosePatient = router + KET_QUA_CAN_LAM_SANG;
      break;
    }

    case CHATBOX: {
      routingAfterChooseHospital = router + CHATBOX_URL;
      break;
    }

    default:
      routingAfterChooseHospital = HOME_URL;
      routingAfterChoosePatient = HOME_URL;
  }

  const collectionRoute = {
    routingAfterChooseHospital,
    routingAfterChoosePatient
  };
  return collectionRoute;
};

export const getSelectedPatientInfo = (
  selectedHospital = {},
  selectedPatient = {}
) => {
  const patientInfo = {
    fullName: "",
    birthdate: "",
    msbn: "",
    mobile: "",
    sex: "",
    cmnd: "",
    email: "",
    career: "",
    dantoc: "",
    city: "", // dung cho medical bill
    country: "",
    address: "",
    relativeFullName: "",
    relativeTypeName: "",
    relativeMobile: ""
  };

  // tên đầy đủ
  patientInfo.fullName = `${
    selectedPatient.surname ? selectedPatient.surname : ""
  } ${selectedPatient.name ? selectedPatient.name : ""}`;

  //  ngày tháng năm sinh
  patientInfo.birthdate = selectedPatient.birthdate
    ? moment(selectedPatient.birthdate).format("DD-MM-YYYY")
    : selectedPatient.birthyear
    ? selectedPatient.birthyear
    : WAIT_UPDATE;

  //  năm sinh
  patientInfo.birthyear = selectedPatient.birthyear
    ? selectedPatient.birthyear
    : "";

  // mã số bệnh nhân
  if (selectedHospital.id === 2) {
    patientInfo.msbn = selectedPatient.bvdhyd_msbn
      ? selectedPatient.bvdhyd_msbn
      : "";
  } else {
    patientInfo.msbn = selectedPatient.bv_id ? selectedPatient.bv_id : "";
  }

  // sex
  patientInfo.sex = Number(selectedPatient.sex) ? MALE : FEMALE;

  // cmnd
  if (selectedHospital.id === 2) {
    patientInfo.cmnd = selectedPatient.cmnd
      ? selectedPatient.cmnd
      : WAIT_UPDATE;
  } else {
    patientInfo.cmnd = selectedPatient.cmnd ? selectedPatient.cmnd : NOT_EXIST;
  }

  // email
  patientInfo.email = selectedPatient.email
    ? selectedPatient.email
    : WAIT_UPDATE;

  // career
  patientInfo.career = selectedPatient.profession
    ? selectedPatient.profession.name
    : WAIT_UPDATE;

  // mobile censored
  const mobileCensored = selectedPatient.mobile_censored
    ? selectedPatient.mobile_censored
    : WAIT_UPDATE;

  patientInfo.mobile = mobileCensored;

  const relativeMobileCensored =
    selectedPatient.relative && selectedPatient.relative.mobile_censored
      ? selectedPatient.relative.mobile_censored
      : WAIT_UPDATE;

  // dantoc, country
  switch (selectedHospital.id) {
    // UMC
    case UMC_HOSPITAL:
    case SKIN_HOSPITAL:
    case MINHANH_HOSPITAL:
      if (selectedPatient.country_code !== "VIE") {
        patientInfo.dantoc = FOREIGN_COUNTRY;
        patientInfo.city = FOREIGN_COUNTRY;
        patientInfo.country =
          selectedPatient.country && selectedPatient.country.name
            ? selectedPatient.country.name
            : FOREIGN_COUNTRY;
      } else {
        patientInfo.country = VIET_NAM;
        patientInfo.city = selectedPatient.city
          ? selectedPatient.city.name
          : WAIT_UPDATE;
        patientInfo.dantoc =
          selectedPatient.dantoc && selectedPatient.dantoc.name
            ? selectedPatient.dantoc.name
            : WAIT_UPDATE;
      }
      break;

    // Nhi đồng 1
    case KID1_HOSPITAL:
      if (selectedPatient.country_code !== "VN") {
        patientInfo.dantoc = FOREIGN_COUNTRY;
        patientInfo.city = FOREIGN_COUNTRY;
        patientInfo.country =
          selectedPatient.country && selectedPatient.country.name
            ? selectedPatient.country.name
            : FOREIGN_COUNTRY;
      } else {
        patientInfo.country = VIET_NAM;
        patientInfo.city = selectedPatient.city
          ? selectedPatient.city.name
          : WAIT_UPDATE;
        patientInfo.dantoc =
          selectedPatient.dantoc && selectedPatient.dantoc.name
            ? selectedPatient.dantoc.name
            : WAIT_UPDATE;
      }

      // relative_mobile_censored cho Nhi dong 1
      patientInfo.relativeMobile = relativeMobileCensored;
      break;

    case CTCH_HOSPITAL:
    case THUDUC_HOSPITAL:
      if (selectedPatient.country_code !== "VN") {
        patientInfo.dantoc = FOREIGN_COUNTRY;
        patientInfo.city = FOREIGN_COUNTRY;
        patientInfo.country =
          selectedPatient.country && selectedPatient.country.name
            ? selectedPatient.country.name
            : FOREIGN_COUNTRY;
      } else {
        patientInfo.country = VIET_NAM;
        patientInfo.city = selectedPatient.city
          ? selectedPatient.city.name
          : WAIT_UPDATE;
        patientInfo.dantoc =
          selectedPatient.dantoc && selectedPatient.dantoc.name
            ? selectedPatient.dantoc.name
            : WAIT_UPDATE;
      }
      break;

    default:
      patientInfo.country = WAIT_UPDATE;
      break;
  }

  const address = selectedPatient.address ? selectedPatient.address : "";
  const city = selectedPatient.city ? selectedPatient.city.name : "";
  const district = selectedPatient.district
    ? selectedPatient.district.name
    : "";
  const ward = selectedPatient.ward ? selectedPatient.ward.name : "";

  // address
  patientInfo.address =
    patientInfo.country !== VIET_NAM
      ? FOREIGN_COUNTRY
      : `${address}, ${ward}, ${district}, ${city}, ${patientInfo.country}`;

  // relativeName
  patientInfo.relativeFullName =
    selectedPatient.relative && selectedPatient.relative.name
      ? selectedPatient.relative.name
      : WAIT_UPDATE;

  //  relativeType
  patientInfo.relativeTypeName =
    selectedPatient.relative &&
    selectedPatient.relative.loai &&
    selectedPatient.relative.loai.name
      ? selectedPatient.relative.loai.name
      : WAIT_UPDATE;

  return patientInfo;
};

export const getInfoFollowHospital = () => {
  const infoHospital = {
    routerFlowAfterChooseSpecialist: "",
    routerFlowAfterChooseRebooking: "",
    router: "",
    defaultCountry: { id: "VIE", name: "Việt Nam" },
    defaultNation: { id: 1, name: "Kinh" },
    mapGoogle: "",
    logoInBill: "",
    mainColor: "",
    googleMapLink: ""
  };
  return infoHospital;
};

export const getInfoMedicalBill = (bill, selectedHospital) => {
  const medicalBillInfo = {
    status: bill.status ? bill.status : "",
    bookingTime: bill.bv_booking_time ? bill.bv_booking_time : "",
    transactionCode: bill.transaction_code_gd ? bill.transaction_code_gd : "",
    bookingDate: bill.booking_date
      ? moment(bill.booking_date, "YYYY-MM-DD").format("DD/MM/YYYY")
      : "",
    description: bill.description ? bill.description : "",
    bookingNumber: bill.booking_number ? bill.booking_number : "",
    BHYT: bill.bhyt_accept && bill.bhyt_accept > 0 ? "Có" : "Không",
    subjectName: bill.subject && bill.subject.name ? bill.subject.name : "",
    roomName: bill.room && bill.room.name ? bill.room.name : "",
    buoi:
      bill.booking_time &&
      bill.booking_time.buoi &&
      bill.booking_time.buoi === 1
        ? " (Buổi sáng)"
        : bill.booking_time.buoi === 2
        ? " (Buổi chiều)"
        : " (Buổi tối)",
    areaName: "",
    fee:
      bill.payment && bill.payment.amount_original
        ? getFormatMoney(bill.payment.amount_original)
        : "",
    advancedPayment: "",
    msbn:
      bill.patient && bill.patient.bv_id
        ? bill.patient.bv_id
        : bill.patient.medpro_id,
    note: bill.booking_note
  };

  switch (selectedHospital.id) {
    case UMC_HOSPITAL: {
      medicalBillInfo.areaName =
        bill.room && bill.room.desciption ? bill.room.description : "";
      medicalBillInfo.buoi =
        bill.ptime && bill.ptime.buoi && bill.ptime.buoi === 1
          ? " (Buổi sáng)"
          : " (Buổi chiều)";
      medicalBillInfo.msbn =
        bill.patient && bill.patient.bvdhyd_msbn
          ? bill.patient.bvdhyd_msbn
          : bill.patient.medpro_id;
      break;
    }

    case SKIN_HOSPITAL: {
      medicalBillInfo.bookingTime = bill.bv_booking_time
        ? bill.bv_booking_time
        : bill.bv_time
        ? bill.bv_time
        : "";
      break;
    }

    case KID1_HOSPITAL: {
      medicalBillInfo.areaName =
        bill.section && bill.section.name ? bill.section.name : "";
      medicalBillInfo.advancedPayment =
        bill.service && bill.service.pay
          ? getFormatMoney(bill.service.pay)
          : "";
      medicalBillInfo.fee =
        bill.service && bill.service.price
          ? getFormatMoney(bill.service.price)
          : "";
      break;
    }

    case MINHANH_HOSPITAL: {
      break;
    }

    case CTCH_HOSPITAL: {
      medicalBillInfo.subjectName =
        bill.subject && bill.subject.name ? bill.subject.name.slice(0, 22) : "";
      break;
    }

    default:
      break;
  }

  return medicalBillInfo;
};

// Step choose Service
export const getNameService = (selectedHospital, service) => {
  return selectedHospital && selectedHospital.id === 4
    ? service.name.substr(0, service.name.lastIndexOf(":")).trim()
    : service.name;
};

export const getInfoPatient = patient => {
  // console.log(patient);
  // console.log('object :>> ', patient);
  const name = get(patient, "name", "");
  const msbn = get(patient, "msbn", "");
  const surname = get(patient, "surname", "");
  const fullName = `${surname} ${name}`.toUpperCase();

  const sex = get(patient, "sex") === 1 ? "Nam" : "Nữ";

  const date = get(patient, "birthdate");
  const year = get(patient, "birthyear");
  const birthdate =
    date !== "" && date !== "Invalid date"
      ? date
      : year !== 0
      ? year
      : NOT_UPDATE;

  const mobile = !!patient.mobile ? patient.mobile : NOT_UPDATE;
  // const mobile = "0833192939";
  const dantoc = get(patient, "nation.name", NOT_UPDATE);

  const cmnd = patient.cmnd ? patient.cmnd : NOT_UPDATE;

  const email = patient.email ? patient.email : NOT_UPDATE;

  const bhyt = patient.insuranceCode ? patient.insuranceCode : NOT_UPDATE;

  const country = get(patient, "country.name", "");
  const city = patient.city && patient.city.name ? `${patient.city.name}` : "";
  const district =
    patient.district && patient.district.name
      ? `${patient.district.name},`
      : "";
  const ward = patient.ward && patient.ward.name ? `${patient.ward.name},` : "";
  const address = patient.address ? `${patient.address},` : "";
  const fullAddress = `${address} ${ward} ${district} ${city}`;

  // thân nhân
  const relativeName = get(patient, "relation.relative_name", "");
  const relativeMobile = get(patient, "relation.relative_mobile", "");
  let relativeEmail = get(patient, "relation.relative_email", "");
  relativeEmail = relativeEmail !== "" ? relativeEmail : NOT_UPDATE;
  const relativeType = get(patient, "relative.name", "");

  return {
    fullName,
    msbn,
    cmnd,
    sex,
    birthdate,
    dantoc,
    mobile,
    email,
    bhyt,
    fullAddress,
    country,
    city,
    relativeName,
    relativeMobile,
    relativeEmail,
    relativeType
  };
};
